import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkStepper from "../../components/atoms/TkStepper";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import TkBackButton from "../../components/molecules/TkBackButton";
import {
  DemanderKbn,
  DemanderRelationship,
  FormClassRetire,
  FormKbn,
  YesOrNoFlug,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { httpAPI_RET005 } from "./api/request.formdata";
import { IAPI_RET005_Request } from "../../type/apiType";
import {
  fakeHeirTableList,
  fakeTableList1,
  fakeTableList2,
  fakeTableList3,
  fakeTableList4,
  schema,
  stepper,
} from "./parts";
import "./_style.scss";
import { API_RET005_BuildReqParams } from "../../utils/buildRequestParams";
import _ from "lodash";

/**
 * SCRR411108 退職手当金の請求手続き（添付書類の登録）
 * 退職手当金請求者が受給権者であることの確認書類を登録する。
 * @return SCRR411108
 */
const SCRR411108 = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const isHeirFlg =
    businessState?.job_35?.demanderKbn === DemanderKbn["相続人"];
  const isRetiree =
    businessState?.job_35?.demanderKbn === DemanderKbn["退職者本人"];

  const [stateFakeTableList, setStateFakeTableList] = useState<any>([]);

  // 初期表示
  useEffect(() => {
    let resArr = _.cloneDeep(fakeHeirTableList);

    // 相続人の場合
    if (!isHeirFlg) {
      // 遺族
      // 戸籍上の配偶者
      if (
        businessState.job_35?.demanderRelationship ===
        DemanderRelationship["戸籍上の配偶者"]
      ) {
        resArr = _.cloneDeep(fakeTableList1);
        const deathCertificate = businessState.job_35?.fileList?.find(
          (item) =>
            item.formClass ===
            FormClassRetire["「死亡診断書」又は「死体検案書」（写）"]
        );

        if (deathCertificate) {
          resArr.find(
            (item) => item.keyword === "deathCertificate"
          )!.setDefaultValue = [
            {
              ...deathCertificate,
              formName: deathCertificate.formName || deathCertificate.fileName,
            },
          ];
        }

        // 内縁の妻又は夫
      } else if (
        businessState.job_35?.demanderRelationship ===
        DemanderRelationship["内縁の妻又は夫"]
      ) {
        resArr = _.cloneDeep(fakeTableList2);
        const deathCertificate = businessState.job_35?.fileList?.find(
          (item) =>
            item.formClass ===
            FormClassRetire["「死亡診断書」又は「死体検案書」（写）"]
        );

        if (deathCertificate) {
          resArr.find(
            (item) => item.keyword === "deathCertificate"
          )!.setDefaultValue = [
            {
              ...deathCertificate,
              formName: deathCertificate.formName || deathCertificate.fileName,
            },
          ];
        }

        const familyRegisterOfSingle = businessState.job_35?.fileList?.find(
          (item) =>
            item.formClass ===
            FormClassRetire["生計維持に関する調査書（様式11号）"]
        );

        if (familyRegisterOfSingle) {
          resArr.find(
            (item) => item.keyword === "familyRegisterOfSingle"
          )!.setDefaultValue = [
            {
              ...familyRegisterOfSingle,
              formName:
                familyRegisterOfSingle.formName ||
                familyRegisterOfSingle.fileName,
            },
          ];
        }

        const certificateOfResidence = businessState.job_35?.fileList?.find(
          (item) =>
            item.formClass === FormClassRetire["職員の死亡当時の住民票の謄本"]
        );

        if (certificateOfResidence) {
          resArr.find(
            (item) => item.keyword === "certificateOfResidence"
          )!.setDefaultValue = [
            {
              ...certificateOfResidence,
              formName:
                certificateOfResidence.formName ||
                certificateOfResidence.fileName,
            },
          ];
        }

        const certificateOfCLRelationship =
          businessState.job_35?.fileList?.find(
            (item) =>
              item.formClass ===
              FormClassRetire["事実上の配偶者であることを証明する書類"]
          );

        if (certificateOfCLRelationship) {
          resArr.find(
            (item) => item.keyword === "certificateOfCLRelationship"
          )!.setDefaultValue = [
            {
              ...certificateOfCLRelationship,
              formName:
                certificateOfCLRelationship.formName ||
                certificateOfCLRelationship.fileName,
            },
          ];
        }

        // その他（生計維持関係あり）
      } else if (
        businessState.job_35?.livelihoodFromRetireeFlg === YesOrNoFlug["有"]
      ) {
        resArr = _.cloneDeep(fakeTableList3);

        const deathCertificate = businessState.job_35?.fileList?.find(
          (item) =>
            item.formClass ===
            FormClassRetire["「死亡診断書」又は「死体検案書」（写）"]
        );

        if (deathCertificate) {
          resArr.find(
            (item) => item.keyword === "deathCertificate"
          )!.setDefaultValue = [
            {
              ...deathCertificate,
              formName: deathCertificate.formName || deathCertificate.fileName,
            },
          ];
        }
        const livingReportOfFamily = businessState.job_35?.fileList?.find(
          (item) =>
            item.formClass ===
            FormClassRetire["生計維持に関する調査書（様式11号）"]
        );

        if (livingReportOfFamily) {
          resArr.find(
            (item) => item.keyword === "livingReportOfFamily"
          )!.setDefaultValue = [
            {
              ...livingReportOfFamily,
              formName:
                livingReportOfFamily.formName || livingReportOfFamily.fileName,
            },
          ];
        }

        // その他（生計維持関係なし）
      } else if (
        businessState.job_35?.livelihoodFromRetireeFlg === YesOrNoFlug["無"]
      ) {
        resArr = _.cloneDeep(fakeTableList4);
        const deathCertificate = businessState.job_35?.fileList?.find(
          (item) =>
            item.formClass ===
            FormClassRetire["「死亡診断書」又は「死体検案書」（写）"]
        );

        if (deathCertificate) {
          resArr.find(
            (item) => item.keyword === "deathCertificate"
          )!.setDefaultValue = [
            {
              ...deathCertificate,
              formName: deathCertificate.formName || deathCertificate.fileName,
            },
          ];
        }
        const familyRegisterOfSingle = businessState.job_35?.fileList?.find(
          (item) =>
            item.formClass ===
            FormClassRetire["生計維持に関する調査書（様式11号）"]
        );

        if (familyRegisterOfSingle) {
          resArr.find(
            (item) => item.keyword === "familyRegisterOfSingle"
          )!.setDefaultValue = [
            {
              ...familyRegisterOfSingle,
              formName: familyRegisterOfSingle.formName,
            },
          ];
        }
      }
    }

    // ユーザタイプが機構の場合
    if (isKiko) {
      let retireeName = resArr.find((item) => item.keyword === "retireeName")!;
      retireeName.contractorNumber = businessState.job_35?.staffName;
      retireeName.showLine = true;
    }

    setStateFakeTableList(resArr);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeFileObj = (data: any) => {
    const baseFileList =
      businessState.job_35?.fileList?.filter(
        (item) =>
          !(
            item.formKbn === FormKbn["退職書類"] &&
            (item.formClass ===
              FormClassRetire["「死亡診断書」又は「死体検案書」（写）"] ||
              item.formClass ===
                FormClassRetire["生計維持に関する調査書（様式11号）"] ||
              item.formClass ===
                FormClassRetire["職員の死亡当時の住民票の謄本"] ||
              item.formClass ===
                FormClassRetire["事実上の配偶者であることを証明する書類"])
          )
      ) ?? [];

    const nextFileList = [...baseFileList];

    data?.deathCertificate &&
      nextFileList.push({
        fileList_staffNo: businessState.job_35?.staffNo,
        facilityNo: businessState.job_35?.facilityNo,
        formKbn: FormKbn["退職書類"],
        formClass: FormClassRetire["「死亡診断書」又は「死体検案書」（写）"],
        fileName: data.deathCertificate[0].formName,
        fileBase64:
          data.deathCertificate[0].fileBase64 || data.deathCertificate[0].file,
      });

    data?.familyRegisterOfSingle &&
      nextFileList.push({
        fileList_staffNo: businessState.job_35?.staffNo,
        facilityNo: businessState.job_35?.facilityNo,
        formKbn: FormKbn["退職書類"],
        formClass: FormClassRetire["生計維持に関する調査書（様式11号）"],
        fileName: data.familyRegisterOfSingle[0].formName,
        fileBase64:
          data.familyRegisterOfSingle[0].fileBase64 ||
          data.familyRegisterOfSingle[0].file,
      });

    data?.livingReportOfCLRelationship &&
      nextFileList.push({
        fileList_staffNo: businessState.job_35?.staffNo,
        facilityNo: businessState.job_35?.facilityNo,
        formKbn: FormKbn["退職書類"],
        formClass: FormClassRetire["生計維持に関する調査書（様式11号）"],
        fileName: data.livingReportOfCLRelationship[0].formName,
        fileBase64:
          data.livingReportOfCLRelationship[0].fileBase64 ||
          data.livingReportOfCLRelationship[0].file,
      });

    data?.certificateOfResidence &&
      nextFileList.push({
        fileList_staffNo: businessState.job_35?.staffNo,
        facilityNo: businessState.job_35?.facilityNo,
        formKbn: FormKbn["退職書類"],
        formClass: FormClassRetire["職員の死亡当時の住民票の謄本"],
        fileName: data.certificateOfResidence[0].formName,
        fileBase64: data.certificateOfResidence[0].fileBase64,
      });

    data?.certificateOfCLRelationship &&
      nextFileList.push({
        fileList_staffNo: businessState.job_35?.staffNo,
        facilityNo: businessState.job_35?.facilityNo,
        formKbn: FormKbn["退職書類"],
        formClass: FormClassRetire["事実上の配偶者であることを証明する書類"],
        fileName: data.certificateOfCLRelationship[0].formName,
        fileBase64:
          data.certificateOfCLRelationship[0].fileBase64 ||
          data.certificateOfCLRelationship[0].file,
      });

    data?.livingReportOfFamily &&
      nextFileList.push({
        fileList_staffNo: businessState.job_35?.staffNo,
        facilityNo: businessState.job_35?.facilityNo,
        formKbn: FormKbn["退職書類"],
        formClass: FormClassRetire["生計維持に関する調査書（様式11号）"],
        fileName: data.livingReportOfFamily[0].formName,
        fileBase64:
          data.livingReportOfFamily[0].fileBase64 ||
          data.livingReportOfFamily[0].file,
      });

    return nextFileList.map((item, index) => ({
      ...item,
      serialNo: index + 1,
    }));
  };

  const makeHttpObj = (obj: any): IAPI_RET005_Request => {
    const reqObj: IAPI_RET005_Request = {
      applyId: businessState.job_35?.applyId ?? 0, // 申請id
      tempSaveStep: 5, // 一時保存ステップ
      businessType: businessState.common?.businessType,
      contractorNo: isKiko
        ? businessState.common?.contractorNo
        : state.authInfo?.contractorNo, // 共済契約者番号
      staffNo: businessState.job_35?.staffNo!, // 退職者法人職員番号
      demanderName: businessState.job_35?.demanderName, // 請求者名
      demanderNameKana: businessState.job_35?.demanderNameKana, // 請求者ｶﾅ
      demanderKbn: businessState.job_35?.demanderKbn, // 請求者区分
      demanderRelationship: businessState.job_35?.demanderRelationship, // 請求者続柄
      demanderRelationshipOthers:
        businessState.job_35?.demanderRelationshipOthers, // 請求者その他続柄
      demanderBirth: businessState.job_35?.demanderBirth, // 生年月日
      tel: businessState.job_35?.tel, // 電話番号
      demanderEmail: businessState.job_35?.demanderEmail, // 請求者メールアドレス
      agentEmail: businessState.job_35?.agentEmail, // 代行者メールアドレス
      demanderZipcode: businessState.job_35?.demanderZipcode, // 請求者住所（郵便番号）
      demanderPrefectureCd: businessState.job_35?.demanderPrefectureCd, // 請求者住所（都道府県）
      demanderCity: businessState.job_35?.demanderCity, // 請求者住所（市区町村）
      demanderAddressOthers: businessState.job_35?.demanderAddressOthers, // 請求者住所（その他）
      nowZipcode: isRetiree
        ? businessState.job_35?.demanderZipcode
        : businessState.job_35?.retirementZipcode, // 現住所（郵便番号）
      nowPrefectureCd: isRetiree
        ? businessState.job_35?.demanderPrefectureCd
        : businessState.job_35?.retirementPrefectureCd, // 現住所（都道府県）
      nowAddressCity: isRetiree
        ? businessState.job_35?.demanderCity
        : businessState.job_35?.retirementAddressCity, // 現住所（市区町村）
      nowAddressOthers: isRetiree
        ? businessState.job_35?.demanderAddressOthers
        : businessState.job_35?.retirementAddressOthers, // 現住所（その他）
      domesticResidenceFlg: obj.domesticResidenceFlg, // 請求者国内居住有無
      retirementYearFirstZipcode:
        businessState.job_35?.retirementYearFirstZipcode, // 退職年度初日住所（郵便番号）
      retirementYearFirstPrefectureCd:
        businessState.job_35?.retirementYearFirstPrefectureCd, // 退職年度初日住所（都道府県）
      retirementYearFirstAddressCity:
        businessState.job_35?.retirementYearFirstAddressCity, // 退職年度初日住所（市区町村）
      retirementYearAddressOthers:
        businessState.job_35?.retirementYearAddressOthers, // 退職年度初日住所（その他）
      retirementReason: businessState.job_35?.retirementReason, // 退職理由（請求者記載）
      nRetireKbn: businessState.job_35?.retireKbn, // 退職手当等の退職の区分
      firstJoinDate: businessState.job_35?.firstJoinDate, // 退職手当等についての勤続期間（自）
      retireDate: businessState.job_35?.retireDate, // 退職手当等についての勤続期間（至）
      livingAssistanceFlg: businessState.job_35?.livingAssistanceFlg, // 生活扶助の有無
      paymentConfirmDate: businessState.job_35?.paymentConfirmDate, // 退職手当等の支払いを受けることになった年月日
      demanderFlg: businessState.job_35?.demanderFlg, // あなたと同順位の請求権保持者の有無
      bankCd: businessState.job_35?.bankCd, // 金融機関コード
      bankName: businessState.job_35?.bankName, // 金融機関名
      branchCd: businessState.job_35?.branchCd, // 支店コード
      branchName: businessState.job_35?.branchName, // 支店名
      accountNameKana: businessState.job_35?.accountNameKana, // 口座名義ｶﾅ
      depositType: obj.depositType, // 預金種目
      accountNo: businessState.job_35?.accountNo, // 口座番号
      livelihoodFromRetireeFlg: businessState.job_35?.livelihoodFromRetireeFlg, // 退職者からの生計維持の有無
      identificationDocsKind: businessState.job_35?.identificationDocsKind, // 本人確認書類の種類
      addPaymentApplyFlg: businessState.job_35?.addPaymentApplyFlg, // 追加支給申請フラグ
      addPaymentReason: businessState.job_35?.addPaymentReason, // 追加支給理由
      addPaymentAmt: businessState.job_35?.addPaymentAmt, // 追加支給金額
      totalPaymentAmtAfterAdd: businessState.job_35?.totalPaymentAmtAfterAdd, // 支給額(追加支給後)
      currentYearLosFrom: businessState.job_35?.currentYearLosFrom, // 本年中に支払を受けた他の退職手当等についての勤続期間（自）
      currentYearLosTo: businessState.job_35?.currentYearLosTo, // 本年中に支払を受けた他の退職手当等についての勤続期間（至）
      currentYearPaymentDecisionDate:
        businessState.job_35?.currentYearPaymentDecisionDate, // 本年中に支払を受けた他の退職手当等の支払を受けることとなった年月日
      currentYearRetirementAllowanceAmt:
        businessState.job_35?.currentYearRetirementAllowanceAmt, // 本年中に支払を受けた他の退職手当等の収入金額
      currentYearWithholdingAmt:
        businessState.job_35?.currentYearWithholdingAmt, // 本年中に支払を受けた他の退職手当等の源泉徴収額
      currentYearScCityAmt: businessState.job_35?.currentYearScCityAmt, // 本年中に支払を受けた他の退職手当等の特別徴収税額（市町村民税）
      currentYearScPrefectureAmt:
        businessState.job_35?.currentYearScPrefectureAmt, // 本年中に支払を受けた他の退職手当等特別徴収税額（道府県民税）
      currentYearGetPaidDate: businessState.job_35?.currentYearGetPaidDate, // 本年中に支払を受けた他の退職手当等の支払いを受けた年月日
      currentYearRetirementKbn: businessState.job_35?.currentYearRetirementKbn, // 本年中に支払を受けた他の退職手当等の退職の区分
      currentYearPayerZipcode: businessState.job_35?.currentYearPayerZipcode, // 本年中に支払を受けた他の退職手当等の支払者の住所(郵便番号)
      currentYearPayerPrefectureCd:
        businessState.job_35?.currentYearPayerPrefectureCd, // 本年中に支払を受けた他の退職手当等の支払者の住所(都道府県)
      currentYearPayerAddressCity:
        businessState.job_35?.currentYearPayerAddressCity, // 本年中に支払を受けた他の退職手当等の支払者の住所(市区町村)
      currentYearPayerAddressOthers:
        businessState.job_35?.currentYearPayerAddressOthers, // 本年中に支払を受けた他の退職手当等の支払者の住所(その他)
      currentYearPayerName: businessState.job_35?.past4yearsPayerName, // 本年中に支払を受けた他の退職手当等の支払者の名称(氏名)
      past4yearsLosFrom: businessState.job_35?.past4yearsLosFrom, // 前年以前4年内（その年に確定拠出年金法に基づく老齢給付金として支給される一時金の支払いを受ける場合には、14年内）の退職手当等についての勤続期間（自）
      past4yearsLosTo: businessState.job_35?.past4yearsLosTo, // 前年以前4年内（その年に確定拠出年金法に基づく老齢給付金として支給される一時金の支払いを受ける場合には、14年内）の退職手当等についての勤続期間（至）
      past4yearsPaymentDecisionDate:
        businessState.job_35?.past4yearsPaymentDecisionDate, // 前年以前4年内の退職手当等の支払を受けることとなった年月日
      past4yearsRetirementAllowanceAmt:
        businessState.job_35?.past4yearsRetirementAllowanceAmt, // 前年以前4年内の退職手当等の収入金額
      past4yearsWithholdingAmt: businessState.job_35?.past4yearsWithholdingAmt, // 前年以前4年内の退職手当等の源泉徴収額
      past4yearsScCityAmt: businessState.job_35?.past4yearsScPrefectureAmt, // 前年以前4年内の退職手当等の特別徴収税額（市町村民税）
      past4yearsScPrefectureAmt: businessState.job_35?.past4yearsScCityAmt, // 前年以前4年内の退職手当等の特別徴収税額（道府県民税）
      past4yearsGetPaidDate: businessState.job_35?.past4yearsGetPaidDate, // 前年以前4年内の退職手当等の支払いを受けた年月日
      past4yearsRetirementKbn: businessState.job_35?.past4yearsRetirementKbn, // 前年以前4年内の退職手当等の退職の区分
      past4yearsPayerZipcode: businessState.job_35?.past4yearsPayerZipcode, // 前年以前4年内の退職手当等の支払者の住所(郵便番号)
      past4yearsPayerPrefectureCd:
        businessState.job_35?.past4yearsPayerPrefectureCd, // 前年以前4年内の退職手当等の支払者の住所(都道府県)
      past4yearsPayerAddressCity:
        businessState.job_35?.past4yearsPayerAddressCity, // 前年以前4年内の退職手当等の支払者の住所(市区町村)
      past4yearsPayerAddressOthers:
        businessState.job_35?.past4yearsPayerAddressOthers, // 前年以前4年内の退職手当等の支払者の住所(その他)
      past4yearsPayerName: businessState.job_35?.past4yearsPayerName, // 前年以前4年内の退職手当等の支払者の名称(氏名)
      retirementFormApplyId: businessState.job_35?.retirementFormApplyId, // 被共済職員退職届申請id
      page1Kbn: businessState.job_35?.page1Kbn, // 1枚目源泉徴収票・特別徴収票の区分
      page1PaymentAmt: businessState.job_35?.page1PaymentAmt, // 1枚目の支払金額
      page1WithholdingAmt: businessState.job_35?.page1WithholdingAmt, // 1枚目の源泉徴収税額
      page1ScAmtCity: businessState.job_35?.page1ScAmtCity, // 1枚目の特別徴収税額（市町村民税）
      page1ScAmtPrefecture: businessState.job_35?.page1ScAmtPrefecture, // 1枚目の特別徴収税額（道府県民税）
      page1LengthOfService: businessState.job_35?.page1LengthOfService, // 1枚目の勤続年数
      page1EmployedDate: businessState.job_35?.page1EmployedDate, // 1枚目の就職年月日
      page1RetiredDate: businessState.job_35?.page1RetiredDate, // 1枚目の退職年月日
      page2Kbn: businessState.job_35?.page2Kbn, // 2枚目源泉徴収票・特別徴収票の区分
      page2PaymentAmt: businessState.job_35?.page2PaymentAmt, // 2枚目の支払金額
      page2WithholdingAmt: businessState.job_35?.page2WithholdingAmt, // 2枚目の源泉徴収税額
      page2ScAmtCity: businessState.job_35?.page2ScAmtCity, // 2枚目の特別徴収税額（市町村民税
      page2ScAmtPrefecture: businessState.job_35?.page2ScAmtPrefecture, // 2枚目の特別徴収税額（道府県民税）
      page2LengthOfService: businessState.job_35?.page2LengthOfService, // 2枚目の勤続年数
      page2EmployedDate: businessState.job_35?.page2EmployedDate, // 2枚目の就職年月日
      page2RetiredDate: businessState.job_35?.page2RetiredDate, // 2枚目の退職年月日
      page3Kbn: businessState.job_35?.page3Kbn, // 3枚目源泉徴収票・特別徴収票の区分
      page3PaymentAmt: businessState.job_35?.page3PaymentAmt, // 3枚目の支払金額
      page3WithholdingAmt: businessState.job_35?.page3WithholdingAmt, // 3枚目の源泉徴収税額
      page3ScAmtCity: businessState.job_35?.page3ScAmtCity, // 3枚目の特別徴収税額（市町村民税）
      page3ScAmtPrefecture: businessState.job_35?.page3ScAmtPrefecture, // 3枚目の特別徴収税額（道府県民税）
      page3LengthOfService: businessState.job_35?.page3LengthOfService, // 3枚目の勤続年数
      page3EmployedDate: businessState.job_35?.page3EmployedDate, // 3枚目の就職年月日
      page3RetiredDate: businessState.job_35?.page3RetiredDate, // 3枚目の退職年月日
      contractorName: businessState.common?.contractorName, // 契約者（法人）名
      fileList: makeFileObj(obj), // ファイルリスト
      receptionDate: "", // 受付日
      screenId: "SCRR411108",
    };
    return API_RET005_BuildReqParams(reqObj);
  };

  const handleSubmit = async (data: any, index: any) => {
    // 持回り情報

    switch (index) {
      case 0: // 一時保存
        // 退職手当金請求更新API実行
        try {
          const res = await httpAPI_RET005({
            ...makeHttpObj(data),
          });
          if (res.resultCd === "I0000") {
            setBusinessState({
              ...businessState,
              job_35: {
                ...businessState.job_35,
                applyId: res.applyId,
                tempSaveStep: 5,
                fileList: makeFileObj(data),
              },
            });
            setState({
              ...state,
              errorMsgId: "",
            });
            setOpen(true);
          } else {
            setState({
              ...state,
              errorMsgId: res.resultCd,
            });
          }
        } catch (error) {
          navigate("/error");
        }
        break;

      case 1: // 次へ
        setBusinessState({
          ...businessState,
          job_35: {
            ...businessState.job_35,
            fileList: makeFileObj(data),
          },
        });
        navigate("/SCRR411109");
        break;
    }
  };

  return (
    <Box data-testid="SCRR411108test" className="SCRR411108">
      <TkStepper
        steps={stepper}
        savaStep={businessState.job_35?.tempSaveStep}
        activeStep={4}
      />

      {!isHeirFlg && (
        <TkInfoManual rule="\n">{labelids.labelid.LBLR411108_01}</TkInfoManual>
      )}

      <TkFakeTable
        list={stateFakeTableList}
        ruleSchema={schema}
        submitButtonGroup={[
          { submitButtonText: "一時保存" },
          { submitButtonText: "次へ" },
        ]}
        buttonGroup={<TkBackButton />}
        onCheckAndSubmit={(e, index) => handleSubmit(e, index)}
      />

      <TkMessageDialog
        open={open}
        onOky={() => setOpen(false)}
        title="一時保存完了"
        contextText="　一時保存が完了しました。"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRR411108;
